module.exports = __webpack_public_path__ + "static/media/pic7.0f4d6d3d.jpg";